import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Like <rect>, but transparent by default
 */
export default function TransparentRect(props) {
    const { style } = props;
    return (_jsx("rect", Object.assign({}, props, { style: { fillOpacity: style.fill ? undefined : 0, ...style } }), void 0));
}
//# sourceMappingURL=TransparentRect.js.map